// @flow
import { combineReducers } from "redux";
import { routerReducer } from "react-router-redux";
import { localeReducer } from "react-localize-redux";
import publicPagesReducer from "./PublicPages";
import publicAccountPagesReducer from "./PublicAccountPages";

export default combineReducers({
  // import reducers that are exported from node packages
  router: routerReducer,
  locale: localeReducer,
  // import envanterium-landing related reducers
  publicpages: publicPagesReducer,
  publicaccountpages: publicAccountPagesReducer
});


// WEBPACK FOOTER //
// ./src/Reducers/index.js